import { Box, Button, Card, CardActions, CircularProgress, Divider, Typography } from '@mui/material';
import moment from 'moment';
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { deletePost, getComments, getPost, getSimilarPosts, likePost, searchPosts } from '../../actions/posts';
import LoadingIcon from '../Icons/LoadingIcon/LoadingIcon';
import SuggestedPosts from '../Posts/SuggestedPosts/SuggestedPosts';
import CommentSection from '../CommentSection/CommentSection';
import styles from './styles'; 
import getAverageColors from '../../utils/getAverageColors';
import placeHolderImage from "../../images/post_placeholder.jpeg";
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import {HiAnnotation} from 'react-icons/hi';
import theme from '../../muiTheme';
import useBeforeRender from '../../hooks/useBeforeRender';
import { hexToRgb, truncate } from '../../utils/utils';
import UserAvatar from '../UserAvatar/UserAvatar';

const ViewPost = ({post}) => {

    //const {post, posts, isLoading} = useSelector((state) => state.posts);
    const dispatch = useDispatch(); 
    const navigate = useNavigate(); 
    const {id} = useParams(); 
    const imageRef = useRef(null); 
    const [backgroundColor, setBackgroundColor] = useState('black'); 
    const [gradientBackground, setGradientBackground] = useState('linear-gradient(63deg, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)'); 
    const user = JSON.parse(localStorage.getItem('profile'));
    const [likes, setLikes] = useState([]); 
    const [comments, setComments] = useState([]);
    const [commentsPage, setCommentsPage] = useState(1);
    const [totalComments, setTotalComments] = useState(0);
    const [commentsLoading, setCommentsLoading] = useState(false);
    const commentRef = useRef(null);
    const containerRef = useRef(null);
    const [sectionHeight, setSectionHeight] = useState(null);
    const [userLiked, setUserLiked] = useState(false); 
    const [colorsFetched, setColorsFetched] = useState(false); 
    const [avColors, setAvColors] = useState({rgb: {r: 0, g: 0, b: 0}, rgb2: {r: 0, g: 0, b: 0}});
    const [messageExpanded, setMessageExpanded] = useState(false); 

    useLayoutEffect(()=>{

        //for when container has rendered, we grab the height and set the section to that height

        if(containerRef.current){

            setSectionHeight(containerRef.current.offsetHeight);

        }


        return () => {
            //for when the component unmounts -- TODO
            

        }

    }, []);

    useEffect(()=>{

        //findout if user liked post
        if(likes){
            let liked = likes.find((like) => like === (user?.result?.sub || user?.result?._id)); 
            setUserLiked(liked);
        }
         

    }, [likes]);

    const Likes = () => {
        if (likes.length > 0) {
          return userLiked
            ? (
              likes.length > 2 ? `You and ${likes.length - 1} others` : `${likes.length} like${likes.length > 1 ? 's' : ''}` 
            ) : (
              `${likes.length}  ${likes.length === 1 ? 'Like' : 'Likes'}`
            );
        }
    
        return '0 Likes'
    };

    // useEffect(()=>{

    //     dispatch(getPost(id));

    // }, [id]);

    // useEffect(()=>{

    //     console.log('similar posts updated: ', post);

    // }, [post.similarPosts]);

    const fetchAVColors = (repeat = true) => {
        if(colorsFetched){
            return; 
        }

        //let imageEl = document.getElementById('post-view-mobile-image'); 
        let avColors = {rgb: {r: 0, g: 0, b: 0}, rgb2: {r: 0, g: 0, b: 0}}; 

        if(post && post.mediaAvColors){

            avColors = JSON.parse(post.mediaAvColors[0]); //will need to adjust this for arrays of media

            console.log('post avColors: ', avColors);

            avColors.rgb = hexToRgb(avColors.avColor1);
            avColors.rgb2 = hexToRgb(avColors.avColor2);

            console.log('post avColors in rgb: ', avColors);
            setAvColors(avColors);
            setColorsFetched(avColors ? true : false);
        }


        let {r, g, b} = avColors.rgb; 
        let {r:r2, g:g2, b:b2} = avColors.rgb2;

        console.log('avColors: ', avColors);


        let background = `rgb(${r}, ${g}, ${b})`; 
        let gradBackground = `linear-gradient(45deg, rgb(${r}, ${g}, ${b}, 1) 0%, rgb(${r2}, ${g2}, ${b2}, 1) 100%)`; 

        setBackgroundColor(background);
        setGradientBackground(gradBackground);
    }

    useLayoutEffect(()=>{

        if(post.media.length > 0 && post.mediaAvColors.length > 0){
            fetchAVColors();
        }
        
    }, []);

    useMemo(()=>{

        //recommended posts will be obtained based on tags
        if(post){

            post.similarPosts = []; //clear last similar posts. 
            dispatch(getSimilarPosts(post));

            setLikes(post.likes); 
            setTotalComments(post.commentCount);

        }

    }, [post]);

    useEffect(()=>{

        //recommended posts will be obtained based on tags
        if(post){

            console.log('post comments changed');
            setComments([]);

            dispatch(getComments(post._id, commentsPage, (error, res) => {

                if(error){
                    return console.warn('Something went wrong fetching comments: ', error);
                }

                console.log('comments res: ', res);
                if(res.data.length > 0){

                    setComments(res.data);
                }

            }));

        }

    }, [post, post?.commentCount]);


    const fetchMoreComments = () => {


        console.log('see more comments invoked, comments length: ', comments.length, ' total comments: ', post.commentCount);


        //get updated post first, then fetch comments
        // dispatch(getPost(id), ()=>{


            if(comments.length < post.commentCount ){

                
                console.log('see more comments invoked inside if statement');

                setCommentsLoading(true);

                dispatch(getComments(post._id, commentsPage+1, (error, res) => {
    
                    if(error){
                        return console.warn('Something went wrong fetching comments: ', error);
                    }
        
                    console.log('comments res: ', res);
                    if(res.data.length > 0){
        
                        setComments([
                            ...comments,
                            ...res.data
                        ]);
                    }

                    setCommentsLoading(false);

                    setCommentsPage(commentsPage+1);
        
                }));
            }
        // });

        

        //setCommentsPage(commentsPage+1);        

    }



    const onComment = (comment) => {

        dispatch(getComments(post._id, commentsPage, (error, res) => {

            if(error){
                return console.warn('Something went wrong fetching comments: ', error);
            }

            console.log('comments res: ', res);
            if(res.data.length > 0){

                setComments([
                    ...res.data
                ]);

                
            }

            setTotalComments(res?.total || 0);

        }));
    }

    // if(isLoading){

    //     return (
    //         <LoadingIcon/>
    //     );
    // }

    if(!post || typeof post === 'undefined'){

        return (
            <div>
                Post not found
            </div> 
        );

    }

    const openTag = (tag) => {
        var query = {
            search:'none',
            tags: tag
        };

        dispatch(searchPosts(query));

        navigate(`/posts/search?searchQuery=none&tags=${tag}`); 
    }

    const handleLikePost = async (event) => {
        if(user?.result){
           dispatch(likePost(post._id));
        }else{
            return
        }

        //Below code is for reflecting like in UI before API responds in case of lengthy response time

        //check if current user liked the post already
        if(likes.find((like) => like === (user?.result?.sub || user?.result?._id))){

            //remove like in UI
            setLikes(likes.filter((id) => id !== (user?.result.googleId || user?.result?._id)));
        } else {

            //add like in UI
            setLikes([...likes, (user?.result?.sub || user?.result?._id)]);

        }
    }

    const goToComments = () => {

        commentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    //remove current post from posts list
    //let suggestedPosts = posts.filter(({_id}) => post._id !== _id);

    return (

        <Box ref={containerRef} style={styles.container}>

        
            <Card  sx={styles.card}>

                {   post.media.length > 0 &&

                    <div style={{...styles.imageSection, background: backgroundColor, background: gradientBackground }} >

                        {/* <div style={{...styles.blurredBackground, backgroundImage:`url("${post.selectedFile || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'}")` }}>

                        </div> */}

                        <img 
                            style={styles.media} 
                            id='post-view-image'
                            src={post.media?.length > 0 ? post.media[0] : placeHolderImage} alt={post.title} />

                    </div>
                }
                

                <div style={{...styles.section, maxHeight: sectionHeight ? sectionHeight+'px' : '75vh'}}>

                    {/* <Link to={`/profile/${post.creator._id}`}>
                        <div style={styles.avatarContainer}>

                            <img style={styles.userAvatar} src={post.creator.profileImage || placeHolderImage}>
                                

                            </img>

                            <div style={styles.userInfo}>
                                <Typography variant="h6" sx={styles.userName}>{post.creator.name}</Typography>
                                <Typography variant="body2" sx={styles.createdAt}>{ moment(post.createdAt).fromNow()}</Typography>
                            </div>

                        </div>
                    </Link> */}

                    <UserAvatar 
                            url={`/profile/${post.creator._id}`} 
                            imageURL={post.creator.profileImage || placeHolderImage} 
                            name={post.creator.name} 
                            createdAt={post.createdAt}
                            sx={{
                                position: 'sticky',
                                top: '0px',
                                zIndex: '3',
                                padding: '20px',
                                paddingBottom: '5px',
                                background: 'white'
                            }}
                            verified={post.creator.verified}
                    />

                    <Box
                        sx={styles.descriptionSection}
                    >


                        

                        <Divider style={{ marginBottom: '20px' }} />

                        <Typography variant="h5" component="h2" sx={{marginBottom: '10px'}}>
                            {post.title}
                        </Typography>

                        <div className="details" style={styles.tagContainer}>

                            {post.tags.map((tag, index)=>(

                                <Typography key={tag+index} variant="body2" sx={styles.postTag} color="textSecondary" onClick={()=>openTag(tag)}>
                                    {`#${tag}`}
                                </Typography>
                                
                            ))}
                        </div>

                        <Typography gutterBottom variant="body1" component="p" sx={{margin: '15px 0px'}}>
                            { messageExpanded ? post.message : truncate(post.message, 200)}
                        </Typography>

                        { post.message.length > 200 && 

                            <Button 
                                variant='faint'    
                                sx={{padding: '3px 15px'}}
                                onClick={()=>setMessageExpanded(prevValue=>!prevValue)}>
                                {messageExpanded ? 'Hide' : 'Read more'}
                            </Button>
                        }

                    </Box>


                    <Box sx={styles.actionsSection}>

                        

                        <CardActions
                            className="cardActions"
                            ref={commentRef}
                            sx={{
                                padding: '2px 20px',
                                position: 'sticky',
                                zIndex: '5',
                                top: '93px',
                                background: 'white',
                                boxShadow: '0px 9px 11px rgb(0 0 0 / 6%)',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex', 
                                    flexDirection: 'row', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    width: '100%',
                                    padding: '20px 0px',
                                    margin: '0px 20px',
                                    borderTop:'1px solid rgba(0, 0, 0, 0.12)'
                                }}
                            >

                                <Box
                                    color="secondary" 
                                    sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}
                                    >
                                    <FavoriteRoundedIcon onClick={handleLikePost} className="like-icon" style={{fontSize: '30px', color: userLiked ? theme.palette.primary.main : theme.palette.secondary.main}} fontSize='small'/>
                                    <Typography variant='body2' color='secondary'>
                                        {Likes()}
                                    </Typography>
                                    

                                </Box>

                                <Box
                                    color="secondary" 
                                    sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginLeft: '30px'}}
                                    onClick={goToComments}
                                    >
                                    <HiAnnotation className="like-icon" style={{fontSize: '30px', color: theme.palette.secondary.main}} fontSize='small'/>
                                    <Typography variant='body2' color='secondary'>
                                        {totalComments} Comment{totalComments === 1 ? '' : 's'}
                                    </Typography>
                                    

                                </Box>

                            </Box>
                            

                            {(user?.result?.sub === post.creator || user?.result?._id === post.creator) && 
                                <Button size="small" color="secondary" onClick={()=>{  dispatch(deletePost(post._id))}}>
                                    <DeleteRoundedIcon fontSize='small'/>
                                </Button>
                            }
                            

                        </CardActions>


                        {/* <Divider style={{ margin: '0px 20px' }} /> */}

                        <Box sx={{padding: '20px'}}>
                            <CommentSection post={post} loading={commentsLoading} initialComments={comments} onComment={onComment} fixedInput={true} fetchMore={(comments.length < post.commentCount)} onFetchMore={fetchMoreComments}/>
                        </Box>
                        
                    </Box>
                    
                    
                            
                        
                        
                    
                    
                </div>

            </Card>

           

            {/* <div style={{marginTop: '50px'}}>
                <SuggestedPosts posts={post.similarPosts || []}/>
            </div> */}
            

        </Box>
    );
}

export default ViewPost; 